import { defineStore } from 'pinia'
import DiagnosticosService from '../services/diagnosticos.service'
const _DiagnosticosService = new DiagnosticosService()

export const useDiagnosticosStore = defineStore('diagnosticosStore', {
  state: () => ({
    listado_diagnosticos: [],
    diagnostico_ppal: '',
    diagnostico_relacionado: ''
  }),
  getters: {
    _listado_diagnosticos: state => state.listado_diagnosticos,
    _diagnostico_ppal: state => state.diagnostico_ppal,
    _diagnostico_relacionado: state => state.diagnostico_relacionado
  },
  actions: {
    obtenerDiagnosticos (name) {
      _DiagnosticosService.listarDiagnosticos(name).then(({ data }) => {
        const array = []
        for (const i of data) {
          array.push({
            ...i,
            name: i.CdCie + ' - ' + i.DesCie
          })
        }
        this.listado_diagnosticos = array
      })
    }
  }
})
